import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Description", -1)
const _hoisted_2 = { class: "content-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Images", -1)
const _hoisted_5 = { class: "grid grid-cols-6 grid-flow-row gap-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.5,4H1.5c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5H14.5c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.02,3.81l-.44-1.46c-.06-.21-.26-.36-.48-.36H5.9c-.22,0-.41,.14-.48,.36l-.44,1.46-.96-.29,.44-1.46c.19-.64,.77-1.07,1.44-1.07h4.2c.67,0,1.24,.43,1.44,1.07l.44,1.46-.96,.29Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.53,15H4.47c-.81,0-1.47-.64-1.5-1.45l-.34-9.87,1-.03,.34,9.87c0,.27,.23,.48,.5,.48h7.07c.27,0,.49-.21,.5-.48l.34-9.87,1,.03-.34,9.87c-.03,.81-.69,1.45-1.5,1.45Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.5,11.62c-.28,0-.5-.22-.5-.5V7.12c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.28-.22,.5-.5,.5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.5,11.62c-.28,0-.5-.22-.5-.5V7.12c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.28-.22,.5-.5,.5Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "content-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { reactive, ref } from "vue";
import swal from '@/_helpers/swal'
import ProductDescriptionFormCollection from "../../description/ProductDescriptionFormCollection.vue";
import { ProductDescription } from "@/models/product/description/ProductDescription";
import ApiService from "@/_services/api.service"

// VARIABLES


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateDescriptionImageStep',
  props: {
  descriptions: {
    type: Object as () => ProductDescription[],
    required: true,
  },
  images: {
    required: true,
  },
  isDisabled: { type: Boolean, default: false },
},
  setup(__props, { expose: __expose }) {

const props = __props;

// IMPORTS

const stepUuidList = ref({
  descriptionsUuid: [],
});


__expose({
  submitStep,
})
const descriptions = reactive(props.descriptions);
const ProductDescriptionFormCollectionRef = ref();
const repeaterImages = ref();
let updatedImages = ref(false);
const images = reactive(props.images);

// FUNCTIONS

async function submitDescription() {
  stepUuidList.value.descriptionsUuid = await ProductDescriptionFormCollectionRef.value.submitProductDescriptions();
}

async function submitStep() {
  await submitImages();
  await submitDescription();
}

function selectImages(index) {
  let imagesUploaded = repeaterImages.value;
  imagesUploaded[index].uuid = "";
  updatedImages.value = true;
}

const createImagePreview = (file) => {
  return (file && file.type.startsWith('image/')) ? URL.createObjectURL(file) : null;
};

async function submitImages() {

  updatedImages.value = false;
  let imagesUploaded = repeaterImages.value;

  imagesUploaded.forEach(async (image, index) => {
    const imageFile = image?.product_image[0]?.file;
    if(image.uuid || !imageFile) return;

    const file = new FormData();
    file.append('file', imageFile);
    file.append('position', index);

    let apiAction = await ApiService.post("images",  file);
    const data = apiAction.data.data;

    images.push({ name: apiAction.data.data })
    image.uuid = data.uuid;
    swal.success('', 'Les images ont été bien enregistrées')
  })
}

async function deleteImage(imageIndex: number) {
  updatedImages.value = true;
  const imageToRemove = repeaterImages.value.splice(
    imageIndex,
    1
  )[0];

  if (imageToRemove.uuid) {
    await ApiService.delete("images/" + imageToRemove.uuid);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createVNode(_component_FormKit, {
        type: "checkbox",
        label: "Descriptions partagées",
        name: "isSharedDescriptions",
        disabled: __props.isDisabled
      }, null, 8, ["disabled"]),
      _createVNode(ProductDescriptionFormCollection, {
        descriptions: descriptions,
        ref_key: "ProductDescriptionFormCollectionRef",
        ref: ProductDescriptionFormCollectionRef,
        name: "product_description",
        isDisabled: __props.isDisabled
      }, null, 8, ["descriptions", "isDisabled"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FormKit, {
          type: "button",
          label: "Enregistrer les descriptions",
          onClick: submitDescription,
          disabled: __props.isDisabled
        }, null, 8, ["disabled"])
      ])
    ]),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_FormKit, {
      type: "checkbox",
      label: "Images partagées",
      name: "isSharedImages",
      disabled: __props.isDisabled
    }, null, 8, ["disabled"]),
    _createVNode(_component_FormKit, {
      id: "repeater",
      name: "images",
      type: "repeater",
      label: "Images",
      modelValue: repeaterImages.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((repeaterImages).value = $event)),
      "add-label": "Ajouter une image",
      disabled: __props.isDisabled
    }, {
      default: _withCtx(({ index }) => [
        _createVNode(_component_FormKit, {
          onChange: ($event: any) => (selectImages(index)),
          type: "file",
          label: `${index + 1}. Image`,
          name: "product_image",
          accept: ".png,.jpg,.jpeg",
          help: "Séléctionez les images à uploader.",
          "inner-class": "max-w-none",
          max: "1",
          disabled: __props.isDisabled
        }, {
          fileItem: _withCtx(({ value }) => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.name,
                  class: "relative"
                }, [
                  _createElementVNode("img", {
                    src: item.url?  item.url: createImagePreview(item.file),
                    alt: "",
                    class: "rounded-md"
                  }, null, 8, _hoisted_6)
                ]))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["onChange", "label", "disabled"]),
        _createVNode(_component_FormKit, {
          type: "hidden",
          name: "uuid"
        })
      ]),
      removeControl: _withCtx(({ index }) => [
        (repeaterImages.value.length > 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: ($event: any) => (deleteImage(index)),
              class: "cursor-pointer formkit-remove-icon block w-5 my-1 formkit-icon"
            }, _hoisted_9, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_FormKit, {
        type: "button",
        label: "Enregistrer les images",
        onClick: submitImages,
        disabled: !_unref(updatedImages)
      }, null, 8, ["disabled"])
    ]),
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _createVNode(_component_FormKit, {
      type: "hidden",
      name: "descriptionListUuid",
      modelValue: stepUuidList.value.descriptionsUuid,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stepUuidList.value.descriptionsUuid) = $event)),
      disabled: __props.isDisabled
    }, null, 8, ["modelValue", "disabled"])
  ], 64))
}
}

})